export default __webpack_public_path__ + "static/media/Tarjetas-2.097ec922.jpg";